export class NotificationSystemQueries {
    public getJobAdHocNotRejectedQuery() {
        return {
            ad_hoc: true,
            rejected: false,
            process_stage: { $lt: 20 },
            completed_as_planned: null,
        };
    }

    public getJobAdHocRejectedQuery() {
        return {
            ad_hoc: true,
            rejected: true,
            process_stage: { $lt: 20 },
            completed_as_planned: null,
        };
    }
}
